import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Loader from "../Chargers/Loader";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import ReactPaginate from 'react-paginate'; 
import $ from 'jquery';
import Select from 'react-select';
import ReactDOM from 'react-dom';  
import { fetchStatusList } from "../../Apis/StatusListing";
import { useNavigate } from 'react-router-dom';


function Stations() {
  document.title = "Stations";
  const [StationData, setStationData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLimit, setselectedLimit] = useState("");
  const [Limit, setLimit] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedChargers, setSelectedChargers] = useState([]);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  let navigate = useNavigate();
  

  const customSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',            // Ensure the select box takes the full width of the container
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,             // Ensure the dropdown appears above other elements
    }),
    control: (provided) => ({
      ...provided,
      minHeight: '40px',        // Ensure the control area is tall enough for visibility
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',       // Limit the height for selected values
      overflowY: 'auto',        // Add scroll if too many values are selected
    }),
  };
  

 



  
  
  // Helper function for handling the select box change
 
  
   console.log("selecgtedchargers", selectedChargers);
   console.log("selectedChargers", selectedChargers);


  
 
 
  
  
  



 

  const fetchChargers = async (currentPage, searchTerm = '') => {
    setLoading(true);
    
    const apiEndpoint = `${BaseURL}/chargers/`;
  
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      
      setChargerData(response.data.data.data || []);
  
  
  
   
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();  // Fetch all chargers for the current page
  }, []);





  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  // Fetch Stations Data without search filter
  const FetchStationsData = async (currentPage, searchTerm = '') => {
    setLoading(true);
    const url = `${BaseURL}/station/?page=${page}&searchText=${searchTerm}&status=${selectedStatus}`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
        setFilteredData(res.data.data);
        setTotalCount(res.data?.totalCount || 0);
        setLimit(res?.data?.limit);
        setPageCount(Math.ceil(res.data.totalCount / res?.data?.limit));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(page, searchQuery); // Pass current page and search query to the fetch function
  }, [page,]); 

  // Handle input change in search field
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

 
  

console.log("ChargerData", ChargerData);

  // Handle submit to fetch filtered data
  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    const page = 1; // Always reset to page 1 when searching
    setPage(page); 
    // Check if the search query is empty
    if (!searchQuery.trim()) {
      // If no search query, call FetchStationsData to fetch all stations
      await FetchStationsData(page); // Ensure this function fetches all stations
      return; // Exit the function early
    }
  
    setLoading(true); // Set loading state to true while fetching
  
    const url = `${BaseURL}/station/?page=${page}&searchText=${searchQuery}&status=${selectedStatus}`;
  
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });
  
      if (res && res.data && res.data.data) {
        setFilteredData(res.data.data); 
        setTotalCount(res.data.data.length); // Update totalCount with filtered data count
        setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on total count and limit
      } else {
        setFilteredData([]); // If no data is returned, set filtered data to empty
        setTotalCount(0); // Update total count to 0 when no data is found
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false); // Set loading state to false after fetching
    }
  };

  const handleStatusType = async (event, userId) => {
    const status = event.target.value;

    // Update local state
    setUserStatuses((prevStatuses) => ({
      ...prevStatuses,
      [userId]: status,
    }));

    const url = `${BaseURL}/station/changestatus/${userId}`;

    const statusData = { status };

    try {
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {

      console.error("Error updating status:", error);
    }
  };

  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };
  useEffect(() => {
    fetchStatusListing();
  }, []);

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/stations`);
    }
console.log("StationData", StationData);
console.log("statuslisting", statusListing);
console.log("Limit", Limit);
const handleStatus = (e) => {
  setSelectedStatus(e.target.value);
}
console.log("selectedchargers", selectedChargers);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
            <div className="row">
            <div className="col-12 col-md-4 mb-3 d-flex justify-content-start align-items-center" style={{ gap: "20px" }}>
  <Link
    className="form-control"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      maxWidth: "150px",
      display: "flex", // Changed to flex for better alignment
      alignItems: "center",
      overflow: "hidden",
      padding: "8px", // Add some padding for better appearance
      whiteSpace: "nowrap", // Prevent text from wrapping
    }}
    to="/stations/add"
  >
    <i className="fa fa-plus"></i> Add Station
  </Link>

</div>
</div>

              <div>
                <hr />
                <div className="row align-items-center">
                  <div className="col-6">
                    <h5 className="mb-0">All Stations({totalCount ? totalCount : "Loading..."})</h5>
                  </div>
                  <div className="col-6 text-right">
                  <form 
  onSubmit={handleSearchSubmit} 
  className="d-flex align-items-center ms-auto" 
  style={{ width: "auto", justifyContent: "flex-end" }} // Ensure it is aligned right
>
  <input
    placeholder="Find Data Here"
    className="form-control d-inline-block"
    style={{
      width: "100%",
      maxWidth: "170px",
      border: "1px solid black",
      marginRight: "10px",
      borderRadius: "34px",
      height: "38px", // Adjust to match the button height
    }}
    value={searchQuery}
    onChange={handleSearchChange}
  />
 
    <select
  
    className="form-control d-inline-block"
    style={{
      width: "100%",
      maxWidth: "150px",
      border: "1px solid black",
      marginRight: "10px",
      borderRadius: "34px",
      height: "38px", // Adjust to match the button height
     
    }}
    
    onChange={handleStatus}
  >
    <option value="">Select Status</option>
    <option value="Active">Active</option>
    <option value="InActive">InActive</option>
    <option value="Deleted">Deleted</option>
    </select>
    
  <button
    type="submit"
    className="btn btn-primary"
    style={{
      height: "38px", // Set the height to match the input
      padding: "0 20px", // Adjust padding for horizontal space
      borderRadius: "34px",
    }}
  >
    Search
  </button>
  <button
    className="btn btn-primary"
    onClick={handleReset} // Calls the handleReset function
    style={{
      marginLeft: "10px", // Space between the buttons
      height: "38px", // Consistent height
      width: "60px", // Slightly smaller width for Reset button
      display: "flex", // Enable flexbox for centering
      justifyContent: "center", // Center horizontally
      alignItems: "center", // Center vertically
      padding: 0, // Ensure no extra padding that could offset centering
    }}
  >Reset
  </button>
</form>
</div>
  </div>
              </div>
            </div>
            <div className="card-body">
              {loading ? (
                <Loader />
              ) : (
                <>
                <div className="table-responsive">
                 
                  <table className="display dataTable" id="advance-1">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Station Name</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Address</th>
                        <th>Created Date</th>
                        <th>Charger Count</th>
                        <th style={{width : "100px"}}>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((u, i) => (
                          <tr key={u?._id}>
                            <td>{(page - 1) * Limit + i + 1}</td>
                             <td>{u?.station_name}</td>
                            <td>{u?.latitude}</td>
                            <td>{u?.longitude}</td>
                            <td>{u?.address}</td>
                            <td>{u?.createdAt}</td>
                            <td> <Link to={`/chargers/${u?._id}`}   className="transaction-links" >{u?.chargerCount ? u?.chargerCount : "0"}</Link></td>
                            <td>
                              <select
                                onChange={(e) => handleStatusType(e, u?._id)}
                                value={userStatuses[u._id] || u.status}
                                className="custom-select"
                                id="statusType"
                                name="statusType"
                              >
                                {statusListing ? (
                                  statusListing.map((statusObj, index) => {
                                    const statusKey = Object.keys(statusObj)[0];
                                    const statusValue = statusObj[statusKey];
                                    return (
                                      <option key={index} value={statusValue}>
                                        {statusValue}
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option>Loading...</option>
                                )}
                              </select>
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                              <Link
                                to={`/stations/view/${u?._id}`}
                                state={{ StationViewData: u }}
                              >
                                <i
                                  className="fa fa-eye"
                                  style={{ fontSize: "18px" }}
                                   title="View Station"
                                ></i>{" "}
                              </Link>
                              &nbsp;&nbsp;
                              <Link
                                to={`/stations/edit/${u?._id}`}
                                state={{ StationEditData: u }}
                              >
                                <i
                                  className="fa fa-edit"
                                  style={{ fontSize: "18px" }}
                                   title="Edit Station"
                                ></i>{" "}
                              </Link>
                              &nbsp;&nbsp;
                              <Link
  to={`/chargers/add/${u?._id}`}
  state={{ StationEditData: u }}
>
  <i
    className="fa fa-plus"
    style={{ fontSize: "18px" }}
    title="Add Charger"
  ></i>
</Link>
&nbsp;&nbsp;
<Link to ={`/assigncharger/${u?._id}`}>
 
  <i
    className="fa fa-hand-o-up"
    style={{ fontSize: "18px",
      pointerEvents: "auto",
      cursor: "pointer",
       
     }}
    title="Assign Charger"
    onClick={""}
  ></i>
  </Link>


    

                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
       
                </div>
                           
                           <div className="pagination-container mt-4" style={{ position: 'sticky', bottom: '0', zIndex: 1000, backgroundColor: 'white' }}>
                                   <ReactPaginate
                                     previousLabel={'Previous'}
                                     nextLabel={'Next'}
                                     breakLabel={'...'}
                                     pageCount={pageCount}
                                     marginPagesDisplayed={2}
                                     pageRangeDisplayed={5}
                                     onPageChange={handlePageClick}
                                     containerClassName={'pagination'}
                                     subContainerClassName={'pages pagination'}
                                     activeClassName={'active'}
                                     forcePage={page - 1} 
                                   />
                                 </div>
                             </>
                
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stations;
